import axios from 'axios';
import Cookies from 'js-cookie';

const apiRoute = process.env.REACT_APP_BACKEND_URL;
const fileApiRoute = process.env.REACT_APP_BACKEND_URL + 'api/image';
const api = axios.create({
    baseURL: apiRoute,
    headers: {
        'Content-Type': 'application/json',
    },
});

const multipartApi = axios.create({
    baseURL: apiRoute,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

multipartApi.interceptors.request.use(
    (config) => {
        const token = Cookies.get('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

const refreshAccessToken = async () => {
    const refreshToken = Cookies.get('refreshToken');
    if (!refreshToken) {
        throw new Error('No refresh token available');
    }

    try {
        const response = await axios.post(`${apiRoute}api/user/auth/token`, { token: refreshToken });
        const newAccessToken = response.data.accessToken;
        // { secure: true } removed because of server not being secured yet, it should be https not http
        // Cookies.set('accessToken', newAccessToken, { secure: true });
        Cookies.set('accessToken', newAccessToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

        return newAccessToken;
    } catch (error) {
        console.error('Error refreshing access token:', error);
        throw error;
    }
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && error.response.data.expired) {
            try {
                const newAccessToken = await refreshAccessToken();

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                return api(originalRequest);
            } catch (refreshError) {
                console.error('Refresh token failed:', refreshError);
                Cookies.remove('user');
                Cookies.remove('accessToken');
                Cookies.remove('refreshToken');
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);


export { api, multipartApi, apiRoute, fileApiRoute };
